import { colors } from '@creditornot/cb-ingredients';
import { Spinner } from '@creditornot/cb-progress';
import React from 'react';
import styled from 'styled-components';

import FacebookIcon from './FacebookIcon';
import FadeTransition from './FadeTransition';

type FacebookButtonProps = {
  children: React.ReactNode;
  className?: string;
  disabled?: boolean;
  loading: boolean;
  onClick: () => void;
  style?: React.CSSProperties;
  iconColor?: string;
};

const Root = styled.button`
  /* normalize */
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
  border: none;
  position: relative;
  overflow: visible;
  text-transform: none;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  z-index: 0;

  user-select: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;

  width: 100%;
  background-color: #1877f2;
  min-height: 56px;
  padding: 8px 24px;
  border-radius: 8px;
  /* ignore-color */
  color: ${({ disabled }) => (disabled ? colors.salt48 : colors.salt100)};
  font-weight: 700;
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
`;

const IconContainer = styled.div<{ visible: boolean; iconColor?: string }>`
  opacity: ${({ visible }) => (visible ? 1 : 0)};
  transition: opacity 150ms ease-in;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 8px 16px;
  color: ${({ iconColor }) => iconColor || 'inherit'};
`;

const SpinnerContainer = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1;

  display: flex;
  align-items: center;
  justify-content: center;
`;

const FacebookButton = ({
  children,
  className,
  disabled = false,
  loading,
  onClick,
  style,
  iconColor,
}: FacebookButtonProps) => {
  return (
    <Root className={className} style={style} onClick={disabled ? undefined : onClick} disabled={disabled}>
      <IconContainer visible={!loading} iconColor={iconColor}>
        <FacebookIcon />
      </IconContainer>

      <SpinnerContainer>
        <FadeTransition show={loading}>
          <Spinner color="white" size="medium" />
        </FadeTransition>
      </SpinnerContainer>

      {!loading && children}
    </Root>
  );
};

export default FacebookButton;
